import React from 'react'
import RestrictedPage from './RestrictedPage'

export * from './RestrictedPage'
export default React.memo(RestrictedPage)
